import ForgotPassword from '../components/ForgotPassword';
import React from 'react';
import action from '../actions/forgotPassword';

export const context = 'forgotPassword';
export class ForgotPasswordRoute extends React.PureComponent {
    render() {
        return <ForgotPassword context={context} action={action} autoComplete={false} />;
    }
}

export default ForgotPasswordRoute;
